import { render } from "./CommissionKpis.vue?vue&type=template&id=a37f84a0&scoped=true"
import script from "./CommissionKpis.vue?vue&type=script&lang=js"
export * from "./CommissionKpis.vue?vue&type=script&lang=js"

import "./CommissionKpis.vue?vue&type=style&index=0&id=a37f84a0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a37f84a0"]])

export default __exports__